import { createFetcher } from '../../Fetcher/Fetcher'
import {
  getBaseUrl,
  LOGIN_ENDPOINT,
  LOGOUT_ENDPOINT,
  ADMIN_ENDPOINT,
  REFRESH_ENDPOINT,
} from '../../constant'

/**
 * Login to account.
 * @Applications
 */
export default class Login {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Login(
        LOGIN_ENDPOINT,
        LOGOUT_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher(),
        REFRESH_ENDPOINT
      )
    }
    return this.instance
  }

  constructor(
    LoginEndpoint,
    LogoutEndpoint,
    adminEndPoint,
    fetcherObj,
    RefreshEndpoint
  ) {
    this.LoginEndpoint = LoginEndpoint
    this.LogoutEndpoint = LogoutEndpoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
    this.RefreshEndpoint = RefreshEndpoint
  }

  static get baseUrl() {
    return getBaseUrl()
  }

  async postLogin(reqData) {
    const url = `${Login.baseUrl + this.adminEndPoint + this.LoginEndpoint}`
    const response = await this.fetcher.postData(url, reqData)
    return response
  }

  async postLogout(reqData) {
    const url = `${Login.baseUrl + this.adminEndPoint + this.LogoutEndpoint}`
    const response = await this.fetcher.postData(url, reqData)
    return response
  }

  async postRefresh(reqData) {
    const url = `${Login.baseUrl + this.RefreshEndpoint}`
    const response = await this.fetcher.postData(url, reqData)
    return response
  }
}
